import { useSelector } from 'react-redux';

import { type Upload, type UploaderStore, UploadStatus, uploadProgressSelector } from '@air/redux-uploader';

type UploadingData = {
  animating: boolean;
  stateText: string;
};

const PERCENT_MULTIPLIER = 100;

export function useUploadingData(upload: Upload): UploadingData {
  const animating = upload.status === UploadStatus.uploading;
  const { progress } = useSelector((state: UploaderStore) => uploadProgressSelector(state, upload.id));

  let stateText = 'Uploading';

  if (upload.status === UploadStatus.completed) {
    stateText = 'Processing';
  } else if (upload.status === UploadStatus.paused) {
    const percentage = upload.file.size > 0 ? Math.round((progress / upload.file.size) * PERCENT_MULTIPLIER) : 0;
    stateText = `Paused ・ ${percentage}%`;
  }

  return { animating, stateText };
}
